<template>
  <div class="toast" role="alert" :class="customClasess" :id="`ks-toast-${_uid}`" :style="customStyles" @click="click">
    <!--style="position: fixed; z-index: 1051; !important;"-->
    <div class="toast-header" :style="headerStyle" v-if="hasSlotheader || showClose" style="z-index: 1052; !important;">
      <slot name="header"></slot>
      <button type="button" class="close" @click.prevent="hide" v-if="showClose">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="toast-body" :style="bodyStyle" v-show="showBody" style="z-index: 1052; !important;">
      <button type="button" class="close" @click.prevent="hide" v-if="showBodyClose">
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-html="content"></div>
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name:     'ks-toast',
  props:    {
    animation:     {
      type:    Boolean,
      default: true
    },
    autohide:      {
      type:    Number,
      default: null
    },
    headerStyle:   {
      type:    String,
      default: ""
    },
    showClose:     {
      type:    Boolean,
      default: false
    },
    showBodyClose: {
      type:    Boolean,
      default: false
    },
    bodyStyle:     {
      type:    String,
      default: ""
    },
    styles:        {
      type:    String,
      default: ""//"position: absolute; top: 30px; right: 30px; z-index: 100"
    },
    classes:       {
      type:    Array,
      default: () => []
    },
    body:          {
      type:    String,
      default: null
    },
    onClick:       {
      type:    Function,
      default: () => {
      }
    },
    position:      {
      type:    String,
      default: 'top' //top, bottom
    },
    direction:     {
      type:    String,
      default: 'right' //right, left
    },
    type:          {
      type:    String,
      default: null //primary, succes, danger
    },
    open:          {
      type:    Boolean,
      default: false
    },
    defaultHide:   {
      type:    Boolean,
      default: true
    }
  },
  computed: {
    hasSlotheader() {
      return !!this.$slots.header;
    },
    customStyles() {
      return `${this.styles} ${this.showing ? 'z-index: 999 !important' : 'z-index: -999 !important'}`
    },
    customClasess() {
      let bg = this.type ? this.type == 'light' ? `bg-${this.type}` : `text-white bg-${this.type}` : '';
      return `${this.classes} ks-toast-${this.position}-${this.direction} ${bg}`
    }
  },
  mounted() {
    $(`#ks-toast-${this._uid}`).toast({animation: this.animation, autohide: false});
    if (this.open) this.show();
    if (this.autohide) {
      this.timeout = setTimeout(() => {
        this.hide();
      }, this.autohide * 1000);
    }
  },
  methods: {
    click(evt) {
      this.onClick(this, evt);
    },
    show(content = null) {
      this.content = content == null ? this.body : content;
      this.showing = true;
      $(`#ks-toast-${this._uid}`).toast('show');
    },
    hide(emit = true) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = null;
      if (this.defaultHide) {
        this.showing = false;
        $(`#ks-toast-${this._uid}`).toast('hide');
      }
      if (emit) this.$emit('onHide', this);
    }
  },
  data() {
    return {
      content:    null,
      showing:    false,
      showBody:   true,
      showHeader: true,
      timeout:    null
    }
  }
}
</script>
<style scoped>

.ks-toast-top-right {
  position: fixed;
  top: 65px;
  right: 25px;
}

.ks-toast-top-left {
  position: fixed;
  top: 65px;
  left: 25px;
}

.ks-toast-bottom-right {
  position: fixed;
  bottom: 55px;
  right: 25px;
}

.ks-toast-bottom-left {
  position: fixed;
  bottom: 55px;
  left: 25px;
}


</style>
